import type { RowData } from "@tanstack/react-table";
import type { ViewTableReactInstance, ViewTableRow } from "./table";

/**
 * A row's TanStack state, as the props `ViewTableRowComponent` compares.
 * TanStack keeps `row` the same object while its selection, expansion, and
 * cells change, so React Compiler would cache these getters per `row`.
 * `table` changes identity with every table state and option change: a
 * compiled render loop that passes it re-reads the row whenever any of them
 * could have changed.
 */
export const getRowRenderState = <TData extends RowData>({
    row,
}: {
    table: ViewTableReactInstance<TData>;
    row: ViewTableRow<TData>;
}) => ({
    isSelected: row.getIsSelected(),
    isSomeSubRowsSelected: row.getIsSomeSelected(),
    isAllSubRowsSelected: row.getIsAllSubRowsSelected(),
    isExpanded: row.getIsExpanded(),
    canSelect: row.getCanSelect(),
    visibleCells: row.getVisibleCells(),
});
